import Swal from 'sweetalert2'

class EfCadastroConfirmacao {
    static get $inject() {
        return ['$state', 'UsuariosService']
    }

    constructor($state, UsuariosService) {
        this.$state = $state
        this.UsuariosService = UsuariosService
    }

    $onInit() {
        this.UsuariosService
            .confirmarCadastro(this.$state.params.token)
            .then(() => {
                return Swal.fire({
                    title: "Cadastro confirmado!",
                    text: "Seu cadastro foi confirmado com sucesso!",
                    icon: "success"
                })
            })
            .catch(({ data: { errors, error } }) => {
                error = errors ? errors[0].error : error;

                if (error === "already_exists") {
                    return Swal.fire({
                        title: "Cadastro já confirmado!",
                        text: "Seu cadastro já foi confirmado anteriormente.",
                        icon: "info"
                    });
                }

                return Swal.fire({
                    title: "Cadastro não confirmado...",
                    text: "Ocorreu um erro ao confirmar seu cadastro.\nPor favor, efetue seu cadastro novamente.",
                    icon: "error"
                });
            })
            .then(() => this.$state.go('login'))
    }
}

angular.module('eficienciaFiscalModule').component('efCadastroConfirmacao', {
    controller: EfCadastroConfirmacao,
    template: `
    <ef-fullscreen-loading message="'Por favor aguarde, estamos confirmando seu cadastro...'"></ef-fullscreen-loading>
    `
})
